const copy = {
  copyright: `\u00A9 ${new Date().getFullYear()} GSA All rights reserved`,
};

export default copy;
